var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('page-header',{attrs:{"has-return":"","page":{
      icon: 'fas fa-file-invoice-dollar',
      title: 'Facturación de Reembolso y Pago Directo',
      routes: ['Inicio', 'Facturación de Reembolso y Pago Directo'],
    }}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }